import { render, staticRenderFns } from "./LocaleField.vue?vue&type=template&id=65ac8012"
import script from "./LocaleField.vue?vue&type=script&lang=js"
export * from "./LocaleField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports